export const anyOf = (cards) => cards.map((card) => ({ card }));
export function cardsOfSuit(holding, suit, ctx) {
    return holding.filter((c) => ctx.effectiveSuit(c) === suit);
}
/** Follow suit if able, else anything. Bridge uses exactly this. */
export function followSuitOrAnything(holding, trick, ctx) {
    if (trick.plays.length === 0)
        return anyOf(holding);
    const follow = cardsOfSuit(holding, trick.ledSuit, ctx);
    return anyOf(follow.length > 0 ? follow : holding);
}
export function isPlayLegal(legal, card, nominate) {
    const entry = legal.find((l) => l.card === card);
    if (!entry)
        return false;
    if (entry.nominate && entry.nominate.length > 0) {
        return nominate !== undefined && entry.nominate.includes(nominate);
    }
    return nominate === undefined;
}
//# sourceMappingURL=legality.js.map